package music.jammers.shared.event.domain.model

import kotlinx.serialization.Serializable
import music.jammers.shared.user.domain.model.User

@Serializable
data class EventMember(
    val id: Long,
    val status: Status,
    val instrumentType: EventInstrument,
    val user: User?,
    val defaultStatus: Status,
) {

    private val readyStatuses = listOf(Status.BOOKED, Status.BOOKED_OPTIONAL, Status.OPTIONAL)

    val isReady: Boolean =
        status in readyStatuses

    val isAvailable: Boolean =
        status != Status.BOOKED

    @Serializable
    enum class Status {

        FREE,
        OPTIONAL,
        RECOMMENDED,
        BOOKED,
        BOOKED_OPTIONAL,
    }
}